// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Insight Studio — scrollbars, focus states, animations */

.insight-scroll {
    scrollbar-width: thin;
    scrollbar-color: #3a3a3a transparent;
}
.insight-scroll::-webkit-scrollbar {
    width: 6px;
}
.insight-scroll::-webkit-scrollbar-track {
    background: transparent;
}
.insight-scroll::-webkit-scrollbar-thumb {
    background-color: #3a3a3a;
    border-radius: 3px;
}
.insight-scroll::-webkit-scrollbar-thumb:hover {
    background-color: #4a4a4a;
}

.insight-select:focus,
.insight-textarea:focus {
    outline: none;
    border-color: #2b97f0 !important;
    box-shadow: 0 0 0 2px rgba(43, 151, 240, 0.15);
}

.insight-textarea::placeholder {
    color: #6b6f76;
}

.insight-send-btn:not(:disabled):hover {
    background-color: #1e7ac7 !important;
}

@keyframes insight-typing-bounce {
    0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
    30% { transform: translateY(-4px); opacity: 1; }
}

.insight-typing-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #9aa0a8;
    display: inline-block;
    animation: insight-typing-bounce 1.2s infinite ease-in-out;
}
.insight-typing-dot:nth-child(2) { animation-delay: 0.15s; }
.insight-typing-dot:nth-child(3) { animation-delay: 0.3s; }

/* Clickable metadata line under a response bubble */
.insight-meta-btn {
    opacity: 0.75;
    transition: opacity 0.15s ease, color 0.15s ease;
}
.insight-meta-btn:hover {
    opacity: 1;
    color: #2b97f0 !important;
}
.insight-meta-btn:focus-visible {
    outline: none;
    color: #2b97f0 !important;
    box-shadow: 0 0 0 2px rgba(43, 151, 240, 0.25);
    border-radius: 4px;
}

/* Right-hand response-details drawer */
.insight-drawer {
    animation: insight-drawer-in 0.18s ease-out;
}
@keyframes insight-drawer-in {
    from { transform: translateX(16px); opacity: 0; }
    to   { transform: translateX(0);    opacity: 1; }
}

/* "Load more" under the drawer's tweet list */
.insight-load-more {
    width: 100%;
    margin-top: 8px;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    background-color: #1b1d21;
    border: 1px solid #2f3336;
    border-radius: 8px;
    color: #c9d1d9;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}
.insight-load-more:hover {
    background-color: #22252a;
    border-color: #3d4045;
}
.insight-load-more:focus-visible {
    outline: none;
    border-color: #2b97f0;
    box-shadow: 0 0 0 2px rgba(43, 151, 240, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/insightStudio.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;IACI,qBAAqB;IACrB,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,gCAAgC;IAChC,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;IACxD,MAAM,2BAA2B,EAAE,UAAU,EAAE;AACnD;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,0DAA0D;AAC9D;AACA,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;;AAE1D,oDAAoD;AACpD;IACI,aAAa;IACb,gDAAgD;AACpD;AACA;IACI,UAAU;IACV,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,2CAA2C;AAC/C;AACA;IACI,OAAO,2BAA2B,EAAE,UAAU,EAAE;IAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AACpD;;AAEA,8CAA8C;AAC9C;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gEAAgE;AACpE;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD","sourcesContent":["/* Insight Studio — scrollbars, focus states, animations */\n\n.insight-scroll {\n    scrollbar-width: thin;\n    scrollbar-color: #3a3a3a transparent;\n}\n.insight-scroll::-webkit-scrollbar {\n    width: 6px;\n}\n.insight-scroll::-webkit-scrollbar-track {\n    background: transparent;\n}\n.insight-scroll::-webkit-scrollbar-thumb {\n    background-color: #3a3a3a;\n    border-radius: 3px;\n}\n.insight-scroll::-webkit-scrollbar-thumb:hover {\n    background-color: #4a4a4a;\n}\n\n.insight-select:focus,\n.insight-textarea:focus {\n    outline: none;\n    border-color: #2b97f0 !important;\n    box-shadow: 0 0 0 2px rgba(43, 151, 240, 0.15);\n}\n\n.insight-textarea::placeholder {\n    color: #6b6f76;\n}\n\n.insight-send-btn:not(:disabled):hover {\n    background-color: #1e7ac7 !important;\n}\n\n@keyframes insight-typing-bounce {\n    0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }\n    30% { transform: translateY(-4px); opacity: 1; }\n}\n\n.insight-typing-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #9aa0a8;\n    display: inline-block;\n    animation: insight-typing-bounce 1.2s infinite ease-in-out;\n}\n.insight-typing-dot:nth-child(2) { animation-delay: 0.15s; }\n.insight-typing-dot:nth-child(3) { animation-delay: 0.3s; }\n\n/* Clickable metadata line under a response bubble */\n.insight-meta-btn {\n    opacity: 0.75;\n    transition: opacity 0.15s ease, color 0.15s ease;\n}\n.insight-meta-btn:hover {\n    opacity: 1;\n    color: #2b97f0 !important;\n}\n.insight-meta-btn:focus-visible {\n    outline: none;\n    color: #2b97f0 !important;\n    box-shadow: 0 0 0 2px rgba(43, 151, 240, 0.25);\n    border-radius: 4px;\n}\n\n/* Right-hand response-details drawer */\n.insight-drawer {\n    animation: insight-drawer-in 0.18s ease-out;\n}\n@keyframes insight-drawer-in {\n    from { transform: translateX(16px); opacity: 0; }\n    to   { transform: translateX(0);    opacity: 1; }\n}\n\n/* \"Load more\" under the drawer's tweet list */\n.insight-load-more {\n    width: 100%;\n    margin-top: 8px;\n    padding: 8px 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    background-color: #1b1d21;\n    border: 1px solid #2f3336;\n    border-radius: 8px;\n    color: #c9d1d9;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n.insight-load-more:hover {\n    background-color: #22252a;\n    border-color: #3d4045;\n}\n.insight-load-more:focus-visible {\n    outline: none;\n    border-color: #2b97f0;\n    box-shadow: 0 0 0 2px rgba(43, 151, 240, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
